import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { class: "tr" }
const _hoisted_3 = { class: "item-name-container" }
const _hoisted_4 = { class: "tr" }
const _hoisted_5 = { class: "item-image-container" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "item-stats-container" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "table"
}
const _hoisted_10 = { class: "tr" }
const _hoisted_11 = {
  key: 1,
  style: {"margin-bottom":"8px"}
}
const _hoisted_12 = { class: "table" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "stat-value" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "stat-value" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "tr" }
const _hoisted_19 = { class: "stat-value" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "stat-value" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "table" }
const _hoisted_24 = { class: "tr" }
const _hoisted_25 = { class: "stat-value" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "stat-value" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "tr" }
const _hoisted_30 = { class: "stat-value" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "stat-value" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "tr" }
const _hoisted_35 = { class: "stat-value" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "stat-value" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "tr" }
const _hoisted_40 = { class: "stat-value" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "stat-value" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "tr" }
const _hoisted_45 = { class: "stat-value" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = { class: "stat-value" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "stat-value" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = { class: "stat-value" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "tr" }
const _hoisted_55 = { class: "stat-value" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "stat-wrapper setting" }
const _hoisted_58 = { class: "stat-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tr", _hoisted_2, [
        _createElementVNode("td", null, [
          _createElementVNode("div", {
            class: "item-type-container",
            style: _normalizeStyle('color:' + _ctx.getItemTypeData().color)
          }, _toDisplayString(_ctx.getItemTypeData().prefix), 5)
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.state.craftedItem.name), 1)
        ])
      ]),
      _createElementVNode("tr", _hoisted_4, [
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              class: "item-image",
              src: require(`../../../assets/img/gear/${_ctx.itemSlot}/${_ctx.state.craftedItem.image}.gif`),
              alt: ""
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.usedStats.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Add up to five bonus stats on this item! "))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.usedStats, (stat) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "used-stat",
                    key: stat
                  }, _toDisplayString(_ctx.statNamesMap[stat[0]] + (['CritChance', 'CritPower'].includes(stat[0]) && ['head', 'body'].includes(_ctx.itemSlot) ? ' -' : ' +') + stat[1]), 1))
                }), 128))
          ])
        ])
      ])
    ]),
    _cache[50] || (_cache[50] = _createElementVNode("div", { style: {"margin-bottom":"8px"} }, null, -1)),
    (_ctx.itemSlot === 'body')
      ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
          _createElementVNode("tr", _hoisted_10, [
            _createElementVNode("td", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.bonusStats.ST = +_ctx.bonusStats.ST === 0 ? _ctx.disableStats ? '0' : '1' : '0')),
              class: _normalizeClass('special-stat-td' + (+_ctx.bonusStats.ST > 0 ? ' green-bg' : '') + (_ctx.disableStats && +_ctx.bonusStats.ST === 0 ? ' disabled-special-stat' : ''))
            }, [...(_cache[25] || (_cache[25] = [
              _createElementVNode("div", null, "S", -1),
              _createElementVNode("div", null, "+1", -1)
            ]))], 2),
            _createElementVNode("td", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.bonusStats.PE = +_ctx.bonusStats.PE === 0 ? _ctx.disableStats ? '0' : '1' : '0')),
              class: _normalizeClass('special-stat-td' + (+_ctx.bonusStats.PE > 0 ? ' green-bg' : '') + (_ctx.disableStats && +_ctx.bonusStats.PE === 0 ? ' disabled-special-stat' : ''))
            }, [...(_cache[26] || (_cache[26] = [
              _createElementVNode("div", null, "P", -1),
              _createElementVNode("div", null, "+1", -1)
            ]))], 2),
            _createElementVNode("td", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.bonusStats.EN = +_ctx.bonusStats.EN === 0 ? _ctx.disableStats ? '0' : '1' : '0')),
              class: _normalizeClass('special-stat-td' + (+_ctx.bonusStats.EN > 0 ? ' green-bg' : '') + (_ctx.disableStats && +_ctx.bonusStats.EN === 0 ? ' disabled-special-stat' : ''))
            }, [...(_cache[27] || (_cache[27] = [
              _createElementVNode("div", null, "E", -1),
              _createElementVNode("div", null, "+1", -1)
            ]))], 2),
            _createElementVNode("td", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.bonusStats.CH = +_ctx.bonusStats.CH === 0 ? _ctx.disableStats ? '0' : '1' : '0')),
              class: _normalizeClass('special-stat-td' + (+_ctx.bonusStats.CH > 0 ? ' green-bg' : '') + (_ctx.disableStats && +_ctx.bonusStats.CH === 0 ? ' disabled-special-stat' : ''))
            }, [...(_cache[28] || (_cache[28] = [
              _createElementVNode("div", null, "C", -1),
              _createElementVNode("div", null, "+1", -1)
            ]))], 2),
            _createElementVNode("td", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.bonusStats.IN = +_ctx.bonusStats.IN === 0 ? _ctx.disableStats ? '0' : '1' : '0')),
              class: _normalizeClass('special-stat-td' + (+_ctx.bonusStats.IN > 0 ? ' green-bg' : '') + (_ctx.disableStats && +_ctx.bonusStats.IN === 0 ? ' disabled-special-stat' : ''))
            }, [...(_cache[29] || (_cache[29] = [
              _createElementVNode("div", null, "I", -1),
              _createElementVNode("div", null, "+1", -1)
            ]))], 2),
            _createElementVNode("td", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.bonusStats.AG = +_ctx.bonusStats.AG === 0 ? _ctx.disableStats ? '0' : '1' : '0')),
              class: _normalizeClass('special-stat-td' + (+_ctx.bonusStats.AG > 0 ? ' green-bg' : '') + (_ctx.disableStats && +_ctx.bonusStats.AG === 0 ? ' disabled-special-stat' : ''))
            }, [...(_cache[30] || (_cache[30] = [
              _createElementVNode("div", null, "A", -1),
              _createElementVNode("div", null, "+1", -1)
            ]))], 2),
            _createElementVNode("td", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.bonusStats.LK = +_ctx.bonusStats.LK === 0 ? _ctx.disableStats ? '0' : '1' : '0')),
              class: _normalizeClass('special-stat-td' + (+_ctx.bonusStats.LK > 0 ? ' green-bg' : '') + (_ctx.disableStats && +_ctx.bonusStats.LK === 0 ? ' disabled-special-stat' : ''))
            }, [...(_cache[31] || (_cache[31] = [
              _createElementVNode("div", null, "L", -1),
              _createElementVNode("div", null, "+1", -1)
            ]))], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.itemSlot === 'body')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_12, [
      (_ctx.itemSlot === 'body')
        ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
            _createElementVNode("td", {
              class: _normalizeClass(+_ctx.bonusStats.ActionPoints > 0 ? 'green-bg' : '')
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.ActionPoints === 0 ? ' gray-text' : ''))
              }, [
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "stat-name" }, " Action Points ", -1)),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.bonusStats.ActionPoints), 1)
              ], 2),
              _withDirectives(_createElementVNode("input", {
                disabled: _ctx.disableStats && +_ctx.bonusStats.ActionPoints === 0,
                type: "range",
                max: "1",
                step: "1",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bonusStats.ActionPoints) = $event))
              }, null, 8, _hoisted_15), [
                [_vModelText, _ctx.bonusStats.ActionPoints]
              ])
            ], 2),
            _createElementVNode("td", {
              class: _normalizeClass(+_ctx.bonusStats.HealingRate > 0 ? 'green-bg' : '')
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.HealingRate === 0 ? ' gray-text' : ''))
              }, [
                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "stat-name" }, " Healing Rate ", -1)),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.bonusStats.HealingRate), 1)
              ], 2),
              _withDirectives(_createElementVNode("input", {
                disabled: _ctx.disableStats && +_ctx.bonusStats.HealingRate === 0,
                type: "range",
                max: "5",
                step: "1",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bonusStats.HealingRate) = $event))
              }, null, 8, _hoisted_17), [
                [_vModelText, _ctx.bonusStats.HealingRate]
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("tr", _hoisted_18, [
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.CritChance > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.CritChance === 0 ? ' gray-text' : ''))
          }, [
            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "stat-name" }, " Crit Chance ", -1)),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.bonusStats.CritChance), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.CritChance === 0,
            type: "range",
            max: "5",
            step: "1",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bonusStats.CritChance) = $event))
          }, null, 8, _hoisted_20), [
            [_vModelText, _ctx.bonusStats.CritChance]
          ])
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.CritPower > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.CritPower === 0 ? ' gray-text' : ''))
          }, [
            _cache[35] || (_cache[35] = _createElementVNode("div", { class: "stat-name" }, " Crit Power ", -1)),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.bonusStats.CritPower), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.CritPower === 0,
            type: "range",
            max: "5",
            step: "1",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.bonusStats.CritPower) = $event))
          }, null, 8, _hoisted_22), [
            [_vModelText, _ctx.bonusStats.CritPower]
          ])
        ], 2)
      ])
    ]),
    _cache[51] || (_cache[51] = _createElementVNode("div", { style: {"margin-bottom":"8px"} }, null, -1)),
    _createElementVNode("table", _hoisted_23, [
      _createElementVNode("tr", _hoisted_24, [
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.NoDR > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.NoDR === 0 ? ' gray-text' : ''))
          }, [
            _cache[36] || (_cache[36] = _createElementVNode("div", { class: "stat-name" }, " Normal DR ", -1)),
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.bonusStats.NoDR), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.NoDR === 0,
            type: "range",
            max: "10",
            step: "1",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.bonusStats.NoDR) = $event))
          }, null, 8, _hoisted_26), [
            [_vModelText, _ctx.bonusStats.NoDR]
          ])
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.NoDT > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.NoDT === 0 ? ' gray-text' : ''))
          }, [
            _cache[37] || (_cache[37] = _createElementVNode("div", { class: "stat-name" }, " Normal DT ", -1)),
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.bonusStats.NoDT), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.NoDT === 0,
            type: "range",
            max: "5",
            step: "1",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.bonusStats.NoDT) = $event))
          }, null, 8, _hoisted_28), [
            [_vModelText, _ctx.bonusStats.NoDT]
          ])
        ], 2)
      ]),
      _createElementVNode("tr", _hoisted_29, [
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.LaDR > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.LaDR === 0 ? ' gray-text' : ''))
          }, [
            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "stat-name" }, " Laser DR ", -1)),
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.bonusStats.LaDR), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.LaDR === 0,
            type: "range",
            max: "10",
            step: "1",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.bonusStats.LaDR) = $event))
          }, null, 8, _hoisted_31), [
            [_vModelText, _ctx.bonusStats.LaDR]
          ])
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.LaDT > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.LaDT === 0 ? ' gray-text' : ''))
          }, [
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "stat-name" }, " Laser DT ", -1)),
            _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.bonusStats.LaDT), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.LaDT === 0,
            type: "range",
            max: "5",
            step: "1",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.bonusStats.LaDT) = $event))
          }, null, 8, _hoisted_33), [
            [_vModelText, _ctx.bonusStats.LaDT]
          ])
        ], 2)
      ]),
      _createElementVNode("tr", _hoisted_34, [
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.FiDR > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.FiDR === 0 ? ' gray-text' : ''))
          }, [
            _cache[40] || (_cache[40] = _createElementVNode("div", { class: "stat-name" }, " Fire DR ", -1)),
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.bonusStats.FiDR), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.FiDR === 0,
            type: "range",
            max: "10",
            step: "1",
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.bonusStats.FiDR) = $event))
          }, null, 8, _hoisted_36), [
            [_vModelText, _ctx.bonusStats.FiDR]
          ])
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.FiDT > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.FiDT === 0 ? ' gray-text' : ''))
          }, [
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "stat-name" }, " Fire DT ", -1)),
            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.bonusStats.FiDT), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.FiDT === 0,
            type: "range",
            max: "5",
            step: "1",
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.bonusStats.FiDT) = $event))
          }, null, 8, _hoisted_38), [
            [_vModelText, _ctx.bonusStats.FiDT]
          ])
        ], 2)
      ]),
      _createElementVNode("tr", _hoisted_39, [
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.PlDR > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.PlDR === 0 ? ' gray-text' : ''))
          }, [
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "stat-name" }, " Plasma DR ", -1)),
            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.bonusStats.PlDR), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.PlDR === 0,
            type: "range",
            max: "10",
            step: "1",
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.bonusStats.PlDR) = $event))
          }, null, 8, _hoisted_41), [
            [_vModelText, _ctx.bonusStats.PlDR]
          ])
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.PlDT > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.PlDT === 0 ? ' gray-text' : ''))
          }, [
            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "stat-name" }, " Plasma DT ", -1)),
            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.bonusStats.PlDT), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.PlDT === 0,
            type: "range",
            max: "5",
            step: "1",
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.bonusStats.PlDT) = $event))
          }, null, 8, _hoisted_43), [
            [_vModelText, _ctx.bonusStats.PlDT]
          ])
        ], 2)
      ]),
      _createElementVNode("tr", _hoisted_44, [
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.ExDR > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.ExDR === 0 ? ' gray-text' : ''))
          }, [
            _cache[44] || (_cache[44] = _createElementVNode("div", { class: "stat-name" }, " Explode DR ", -1)),
            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.bonusStats.ExDR), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.ExDR === 0,
            type: "range",
            max: "10",
            step: "1",
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.bonusStats.ExDR) = $event))
          }, null, 8, _hoisted_46), [
            [_vModelText, _ctx.bonusStats.ExDR]
          ])
        ], 2),
        _createElementVNode("td", {
          class: _normalizeClass(+_ctx.bonusStats.ExDT > 0 ? 'green-bg' : '')
        }, [
          _createElementVNode("div", {
            class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.ExDT === 0 ? ' gray-text' : ''))
          }, [
            _cache[45] || (_cache[45] = _createElementVNode("div", { class: "stat-name" }, " Explode DT ", -1)),
            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.bonusStats.ExDT), 1)
          ], 2),
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.disableStats && +_ctx.bonusStats.ExDT === 0,
            type: "range",
            max: "5",
            step: "1",
            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.bonusStats.ExDT) = $event))
          }, null, 8, _hoisted_48), [
            [_vModelText, _ctx.bonusStats.ExDT]
          ])
        ], 2)
      ]),
      (_ctx.itemSlot === 'body')
        ? (_openBlock(), _createElementBlock("tr", _hoisted_49, [
            _createElementVNode("td", {
              class: _normalizeClass(+_ctx.bonusStats.RadResistance > 0 ? 'green-bg' : '')
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.RadResistance === 0 ? ' gray-text' : ''))
              }, [
                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "stat-name" }, " Radiation R ", -1)),
                _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.bonusStats.RadResistance), 1)
              ], 2),
              _withDirectives(_createElementVNode("input", {
                disabled: _ctx.disableStats && +_ctx.bonusStats.RadResistance === 0,
                type: "range",
                max: "30",
                step: "1",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.bonusStats.RadResistance) = $event))
              }, null, 8, _hoisted_51), [
                [_vModelText, _ctx.bonusStats.RadResistance]
              ])
            ], 2),
            _createElementVNode("td", {
              class: _normalizeClass(+_ctx.bonusStats.PoisonResistance > 0 ? 'green-bg' : '')
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.PoisonResistance === 0 ? ' gray-text' : ''))
              }, [
                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "stat-name" }, " Poison R ", -1)),
                _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.bonusStats.PoisonResistance), 1)
              ], 2),
              _withDirectives(_createElementVNode("input", {
                disabled: _ctx.disableStats && +_ctx.bonusStats.PoisonResistance === 0,
                type: "range",
                max: "30",
                step: "1",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.bonusStats.PoisonResistance) = $event))
              }, null, 8, _hoisted_53), [
                [_vModelText, _ctx.bonusStats.PoisonResistance]
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("tr", _hoisted_54, [
        (_ctx.itemSlot === 'body')
          ? (_openBlock(), _createElementBlock("td", {
              key: 0,
              class: _normalizeClass(+_ctx.bonusStats.CarryWeight > 0 ? 'green-bg' : '')
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('stat-wrapper' + (_ctx.disableStats && +_ctx.bonusStats.CarryWeight === 0 ? ' gray-text' : ''))
              }, [
                _cache[48] || (_cache[48] = _createElementVNode("div", { class: "stat-name" }, " Carry Weight ", -1)),
                _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.bonusStats.CarryWeight), 1)
              ], 2),
              _withDirectives(_createElementVNode("input", {
                disabled: _ctx.disableStats && +_ctx.bonusStats.CarryWeight === 0,
                type: "range",
                max: "30",
                step: "1",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.bonusStats.CarryWeight) = $event))
              }, null, 8, _hoisted_56), [
                [_vModelText, _ctx.bonusStats.CarryWeight]
              ])
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_57, [
            _cache[49] || (_cache[49] = _createElementVNode("div", { class: "stat-name" }, " Equip? ", -1)),
            _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.equipAfter === '1' ? 'Yes' : 'No'), 1),
            _withDirectives(_createElementVNode("input", {
              type: "range",
              max: "1",
              step: "1",
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.equipAfter) = $event))
            }, null, 512), [
              [_vModelText, _ctx.equipAfter]
            ])
          ])
        ])
      ])
    ]),
    _cache[52] || (_cache[52] = _createElementVNode("div", { style: {"margin-bottom":"8px"} }, null, -1)),
    _createVNode(_component_GenericButton, {
      onClick: _ctx.craftItem,
      "is-disabled": !_ctx.usedStats.length,
      text: _ctx.getButtonText(),
      width: "95%"
    }, null, 8, ["onClick", "is-disabled", "text"])
  ], 64))
}